import axios from 'axios'

import { Agent } from 'types'

export const getAgents = async () => {
  return (await axios.get<Agent[]>('/agents')).data
}
